export function notificationAction(url?: string | null) {
  if (
    url === "/purchases" ||
    (url && /^\/seller\/listings#order-[a-zA-Z0-9-]+$/.test(url))
  )
    return { url, label: "View order" };
  if (url && /^\/marketplace\/listings\/[1-9][0-9]*$/.test(url))
    return { url, label: "View listing" };
  if(url && /^\/live-shows\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(url))
    return {url,label:"View show"};
  return null;
}

